import React, { useEffect, useState } from "react";
import TableLoader from "../../../Skeleton/TableLoader";
import { Link } from "react-router-dom";
import { Button } from "@mui/material";
// import { useAuth } from "../Auth/Auth";
import { apiHeader } from "../../../utils/apiHeader";
import axios from "axios";
import Pagination from "../../../utils/Paginate";
import { globalConfig } from "../../../config/config";
// const querystring = require("querystring");
const ListContentTypes = () => {
  const [currentPage, setCurrentPage] = useState(1);
//   const { token, userMetadata } = useAuth();
	const token = globalConfig.hardcoded_header;
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [state, setState] = useState({
    contentTypes: [],
    filteredContentTypes: [],
  });

  useEffect(() => {
    handleOnLoad();
  }, []);

  useEffect(() => {
    handleSearch(search);
  }, [search]);
  useEffect(() => {
    console.log(state);
  }, [state]);
  const handleOnLoad = () => {
    setLoading(true);
    axios
      .get(`${globalConfig.apiDatahubUrl}/content-types `, apiHeader(token))
      .then((res) => {
        const contentTypes = res.data;
        console.log(contentTypes);
        setState({
          ...state,
          contentTypes: contentTypes,
          filteredContentTypes: contentTypes,
        });
        setLoading(false);
        console.log(res.data[0]);
      })
      .catch((x) => {
      });
  };
  function onDelete(event) {
    let deleteID = event.target.id;
    axios
      .delete(
        `${globalConfig.apiDatahubUrl}/content-types/` + deleteID,
        apiHeader(token)
      )
      .then((res) => {
        console.log("Delete Response:" + res.data);
        setState({ ...state, contentTypes: [], filteredContentTypes: [] });
        handleOnLoad();
      })
      .catch((err) => console.log("Err delete:" + err));

    setState({ ...state, contentTypes: [], filteredContentTypes: [] });
    handleOnLoad();
    // this.props.history.push("/list-contents");
  }

  const handleSearch = (search) => {
    let URL = `${globalConfig.apiDatahubUrl}/content-types?filter[limit]=50`;
    URL += `&filter[where][or][0][contentTypeName][regexp]=/(${search})/i&filter[where][or][1][contentTypeDescr][regexp]=/(${search})/i`;
    axios.get(URL, apiHeader(token)).then((res) => {
      const contentTypes = res.data;
      console.log(contentTypes);
      setState({ ...state, filteredContentTypes: contentTypes });
      console.log(res.data[0]);
    })
    .catch((x) => {
    });
  };

  const indexOfLastData = currentPage * globalConfig.dataPerPage;
  const indexOfFirstData = indexOfLastData - globalConfig.dataPerPage;
  const currentData = state.filteredContentTypes.slice(
    indexOfFirstData,
    indexOfLastData
  );

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  //handler for page
  const handlePage = (page) => {
    setCurrentPage(page);
  };
  return (
    <form>

    	<div style={{ display: "flex", justifyContent: "space-between" }}>
    		<h4>Content Types</h4>
		<div style={{display:"flex",justifyContent:"flex-end"}}>
        	<Link to="/breeze/create-content-type">
          <Button
            variant="contained"
            color="success"
          >
            Create
          </Button>
        </Link>&nbsp;
        {/*
        <Link to="/breeze/list-content-types">
          <Button
            variant="contained"
            color="warning"
          >
            Types
          </Button>
        </Link>&nbsp;
        */}
		<Link to="/breeze">
			<Button variant="contained">Go Back</Button>
		</Link>
		</div>
		</div>
		<hr/>

      <div className="container-fluid">

        <div className="form-group row">
          <table className="table table-bordered table-striped">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">Name</th>
                <th scope="col">Content Object</th>
                <th scope="col">Description</th>
                <th scope="col">Code</th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            <tbody>
              {!loading ? (
                currentData.map(
                  ({
                    contentTypeId,
                    contentTypeName,
                    contentId,
                    contentTypeDescr,
                    contentTypeValueCode,
                  }) => {
                    return (
                      <tr>
                        <td>
                          <Link
                            to={{
                              pathname: "/manage-content-types",
                              search: `?id=${contentTypeId}`,
                            }}
                          >
                            {contentTypeId}
                          </Link>
                        </td>
                        <td>
                          <Link
                            to={{
                              pathname: "/manage-content-types",
                              search: `?id=${contentTypeId}`,
                            }}
                          >
                            {contentTypeName}
                          </Link>{" "}
                        </td>
                        <td>
                          <Link
                            to={{
                              pathname: "/manage-content-types",
                              search: `?id=${contentTypeId}`,
                            }}
                          >
                            {contentId}{" "}
                          </Link>
                        </td>
                        <td>
                          <Link
                            to={{
                              pathname: "/manage-content-types",
                              search: `?id=${contentTypeId}`,
                            }}
                          >
                            {" "}
                            {contentTypeDescr}
                          </Link>
                        </td>
                        <td>
                          <Link
                            to={{
                              pathname: "/manage-content-types",
                              search: `?id=${contentTypeId}`,
                            }}
                          >
                            {" "}
                            {contentTypeValueCode}
                          </Link>
                        </td>
                        <td>
                          <Link
                            className="btn btn-success"
                            to={{
                              pathname: "/manage-content-types",
                              search: `?id=${contentTypeId}`,
                            }}
                          >
                            Edit{" "}
                          </Link>
                          &nbsp;
                          <button
                            onClick={onDelete}
                            id={contentTypeId}
                            className="btn btn-danger"
                          >
                            Delete
                          </button>
                        </td>
                      </tr>
                    );
                  }
                )
              ) : (
                <tr>
                  {new Array(6).fill(0).map((_, index) => (
                    <TableLoader key={index} theme={"dark"} />
                  ))}
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      <Pagination
        dataPerPage={globalConfig.dataPerPage}
        totaldata={state.filteredContentTypes.length}
        paginate={paginate}
        currentPage={currentPage}
        onChange={handlePage}
      />
    </form>
  );
};

export default ListContentTypes;
